export const state = () => ({
	offers: null,
	applicationOffers: null,
	companyOffers: null,
	search: null,
	order: {
		order_by: 'created_at',
		order_dir: 'desc',
	},
	status: null,
	has_ticket: null,
});

export const mutations = {
	setOffers(state: any, payload: any) {
		state.offers = payload;
	},
	setApplicationOffers(state: any, payload: any) {
		state.applicationOffers = payload;
	},
	setCompanyOffers(state: any, payload: any) {
		state.companyOffers = payload;
	},
	setSearch(state: any, payload: any) {
		state.search = payload;
	},
	setOrder(state: any, payload: any) {
		state.order = payload;
	},
	setStatus(state: any, payload: any) {
		state.status = payload;
	},
	setHasTicket(state: any, payload: any) {
		state.has_ticket = payload;
	},
};

export const getters = {
	getOffers: (state: any) => state.offers,
	getApplicationOffers: (state: any) => state.applicationOffers,
	getCompanyOffers: (state: any) => state.companyOffers,
	getSearch: (state: any) => state.search,
	getOrder: (state: any) => state.order,
	getStatus: (state: any) => state.status,
	getHasTicket: (state: any) => state.has_ticket,
};

export const actions = {
	getJobOffers(state: any, payload: any) {
		const { jobUuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/jobs/${jobUuid}/job-offers`, { params: data })
				.then((res) => {
					state.commit('setOffers', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getJobApplicationOffers(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/jobs/applications/${payload}/job-offers`)
				.then((res) => {
					state.commit('setApplicationOffers', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getCompanyOffers(state: any, payload: any) {
		const company = state.rootState.auth.user.company.uuid;
		const url = payload?.url || `/api/company/${company}/job-offers`;

		let data = {
			has_ticket: state.state.has_ticket,
			status: state.state.status,
			...payload.data,
		};

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url, { params: data })
				.then((res) => {
					state.commit('setCompanyOffers', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	createJobOfferTicket(state: any, payload: any) {
		const { job_offer_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/job-offers/${job_offer_uuid}/tickets`, data)
				.then((res) => {
					const newTicket = res.data;
					let offers = JSON.parse(JSON.stringify(state.state.companyOffers));

					offers.data = offers.data.map((offer) => {
						if (offer.uuid === job_offer_uuid) {
							offer.ticket = newTicket;
						}
						return offer;
					});

					state.commit('setCompanyOffers', offers);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	downloadCandidateCv(state: any, job_offer_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/job-offers/${job_offer_uuid}/download-cv`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setSearch(state: any, payload: any) {
		state.commit('setSearch', payload);
	},

	setOrder(state: any, payload: any) {
		state.commit('setOrder', payload);
	},

	setStatus(state: any, payload: any) {
		state.commit('setStatus', payload);
	},

	setHasTicket(state: any, payload: any) {
		state.commit('setHasTicket', payload);
	},
};
